<template>
  <div>


    <div class="wrapper wrapper-full-page login-wrapper">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="login-box">

                <form @submit.prevent="login({ email, password })">
                  <div class="" data-background="color" data-color="blue">
                    <div class="card-header text-center">
                      <a href="//taptasty.com"><img src="/static/img/logo.png" class="logo"></a>
                      <h4 class="purple mar-to-0 mar-bt-25">Recover Password</h4>
                    </div>
                    <div class="card-content">
                      <p class="text-success" v-show="recoverMsg !== ''">
                        {{ recoverMsg }}
                      </p>
                      <p class="text-danger" v-show="errors.has('error')">
                        {{ getError('error') }}
                      </p>
                      <div class="form-group">
                        <!-- <label>Email address</label> -->
                        <input type="email"
                                name="email"
                                placeholder="Email*"
                                class="form-control"
                                v-model="model.email"
                                v-validate="modelValidations.email">
                        <small class="text-danger" v-show="errors.has('email')">
                          {{ getError('email') }}
                        </small>
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button type="submit"  @click.prevent="validate"  class="btn btn-orange-purple btn-fill btn-wd ">Let's go</button>
                    </div>
                  </div>
                </form>
            </div>
          </div>
        </div>


        <div class="full-page-background"></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Register</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  // import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  export default {
    data () {
      return {
        model: {
          email: ''
        },
        modelValidations: {
          email: {
            required: true,
            email: true,
            min: 4
          }
        }
      }
    },
    computed: {
      ...mapFields(['email'])
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        // console.warn(this.errors)
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.recover()
          }
        })
      },
      recover () {
        var self = this
        var creds = {
          email: this.model.email,
          company_id: -1
        }
        // console.warn(self.$session)
        this.apiRequest('/recover', 'POST', creds, function (response) {
          if (response.status === true) {
            swal(
              '',
              response.data['message'] ? response.data['message'] : 'Please check your email adreess to get the reset code.',
              'success'
            ).catch({})

            self.$router.push('/reset')
          } else {
            // handle errors
            for (var prop in response.errors) {
              if (response.errors.hasOwnProperty(prop)) {
                console.warn(prop)
                self.errors.add(prop, response.errors[prop])
              }
            }
          }
        })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Recover.vue